import * as React from 'react';
import styles from './index.less';
import { withRouter, history } from 'umi';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import { RouteComponentProps } from 'react-router';
import RecommendThemes from './RecommendThemes';

interface SuccessProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
}

function Success({ match, dispatch }: SuccessProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tip}>
        <i className={`freelog fl-icon-a-chenggongzhengqueduigou1 ${styles['tip-icon']}`} />
        <div className={styles['tip-text']}>节点创建成功</div>
      </div>

      <RecommendThemes nodeID={Number(match.params.id)} />
    </div>
  );
}

export default withRouter(connect()(Success));
